import { Expose } from "class-transformer";
import type { ProfileMigrationStateEnum } from "../../../../features/profile/constants/profile-migration-state.enum";

export class ProfileMigrationDto {
  @Expose()
  migrationState!: ProfileMigrationStateEnum;

  @Expose()
  message!: string;

  @Expose()
  startedAt!: string | null;

  @Expose()
  completedAt!: string | null;
}
